<template>
    <hts-slide-over
        :show="props.show"
        color="main"
        :submit="handleSubmitFormAddArea"
        :width="40"
        :undo-enable="true"
        @close="closeOverSide"
        @undo="undo()">
        <template #body>
            <hts-card>
                <template #title>
                    <h3 class="title">
                        <hi-forward-icon class="icon overturned" />
                        <span class="label">
                            {{ $t('labels.createArea') }}
                        </span>
                    </h3>
                </template>
                <div
                    class="grid gap-5"
                    :class="columnClass">
                    <hts-form-input
                        :label="$t('labels.companyName')"
                        :placeholder="companyName"
                        :color="props.color"
                        :disabled="true"
                        name="company"
                        prop="company" />
                    <hts-form-input
                        v-model="dataFormAddArea.name"
                        :label="$t('labels.name')"
                        :color="props.color"
                        :required="true"
                        name="name"
                        prop="name" />
                    <select-node @change-input="(nodeData:any)=>setPrimaryNode(nodeData)" />
                    <hts-form-input
                        v-model="dataFormAddArea.description"
                        :label="$t('labels.description')"
                        :color="props.color"
                        name="description"
                        prop="description" />
                </div>
            </hts-card>
        </template>
    </hts-slide-over>
</template>

<script setup lang="ts">
import dataForm, { IArea } from './imports/model'
import SelectNode from '~~/src/pages/admincp/node/ignore/autocomplete/select-node.vue'
const props = defineProps({
  show: {
    type: Boolean,
    default: false,
    required: true
  },
  color: {
    type: String,
    default: 'theme'
  },
  sizeSlideOver: {
    type: Number,
    default: 0
  },
  sizeItemInput: {
    type: String,
    default: 'small'
  },
  column: {
    type: Number,
    default: 1
  }
})
const store = $store()
const companyName = ref('')
const dataFormAddArea = reactive({ ...dataForm.initValue })
const nodeId = ref('')
const emits = defineEmits(['close', 'refreshTables', 'addNewArea'])
onMounted(() => {
  companyName.value = store.system.company.name
})

const closeOverSide = () => {
  Object.assign(dataFormAddArea, { ...dataForm.initValue })
  emits('close')
}

const undo = () => {
  Object.assign(dataFormAddArea, { ...dataForm.initValue })
}

const setPrimaryNode = (nodeData: any) => {
  nodeId.value = nodeData._id
}

const handleSubmitFormAddArea = () => {
  const api = $url.area.create
  const dataRequest = {
    ...dataFormAddArea,
    primaryNode: nodeId.value
  }
  $api(api, { body: dataRequest })
    .then((data) => {
      if (!data) {
        return true
      }
      const responseData: any = data.data.value
      if (responseData.success) {
        emits('refreshTables')
        emits('addNewArea', responseData.data)
        process.client && $toast().success($t('labels.addSuccess'))
        emits('close')
        undo()
      }
    })
    .catch((error: any) => error)
}

const columnClass = computed(() => {
  if ($lodash.inRange(props.column, 1, 12)) {
    return `grid-cols-${props.column}`
  }
  return 'grid-cols-5'
})
</script>
